/** Decodes terrarium RGBA pixels to metres: (R * 256 + G + B / 256) - 32768. Sea floor is clamped to sea level. */
export function decodeTerrarium(rgba: Uint8ClampedArray): Float32Array {
  const h = new Float32Array(rgba.length / 4);
  for (let i = 0; i < h.length; i++) {
    h[i] = Math.max(0, rgba[i * 4] * 256 + rgba[i * 4 + 1] + rgba[i * 4 + 2] / 256 - 32768);
  }
  return h;
}
